export const TEMPLATE_PLACEHOLDER_LINK = 'withjoy.com/name-and-name';
export const HANDWRITING_GUIDE_LINE_LAYER_NAME = 'handwritingGuideLine';
